import React from "react";
import "./carloanbanner.scss";
import SectionWrapper from "../common/SectionWrapper";
import { AppImages } from "../../Images/images";

export default function CarLoanBanner() {
  return (
    <SectionWrapper>
      <div id="carloanbanner">
        <div className="carloanbanner-container">
          <div className="carloanbanner-info">
            <h1>COMING SOON!</h1>
            <p>
              Forem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus.
            </p>
          </div>
          <div className="carloanbanner-image">
            <img
              loading={"lazy"}
              className="carloan-img"
              src={AppImages.ExploreLoan}
            />
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
